// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-primary: #000000;
  --color-white: #ffffff;
  --color-red: #ff0000;
  --color-blue: #00a2ed;
  --color-secondary: rgb(34, 34, 34);
  --font-white: rgb(250, 249, 248);
  --font-light-grey: #a4a4a4;
  --font-medium: 18px !important;
  --medium-screen: 640px !important;
  --small-screen: 960px; }

.app-component {
  height: 80% !important;
  width: 80% !important; }

@media only screen and (max-width: 640px) {
  .app-component {
    width: 95% !important; } }

.app-topbar {
  height: 32px !important;
  width: 100% !important;
  color: var(--font-white) !important;
  border-bottom-right-radius: unset !important;
  border-bottom-left-radius: unset !important; }

.close-button:hover {
  color: var(--color-white);
  background-color: var(--color-red); }

.title-bar {
  width: calc(100% - 140px) !important; }

.app-top-functions {
  width: 100px !important; }

.maximized {
  width: 100% !important;
  height: calc(100% - 40px) !important; }

.app-content-container {
  height: 100% !important;
  width: 80% !important; }

.maximized-application {
  height: 100% !important;
  width: 100% !important; }

.app-sidebar {
  height: 100% !important;
  width: 20% !important; }

.app-content {
  height: calc(100% - 32px) !important;
  width: 100% !important;
  overflow-y: scroll !important;
  overflow-x: hidden !important; }

.scrollbar::-webkit-scrollbar {
  width: 10px; }

.scrollbar::-webkit-scrollbar-thumb {
  background-color: #babac0;
  border-radius: 16px; }

.scrollbar::-webkit-scrollbar-button {
  display: none; }

.app-title {
  border-bottom-right-radius: unset !important;
  border-bottom-left-radius: unset !important;
  width: 200px !important;
  height: 100% !important; }

.sidebar-list {
  color: var(--font-white) !important; }

.sidebar-list-item {
  cursor: pointer !important;
  padding: 10px !important; }

.sidebar-list :hover {
  background-color: #323130 !important; }

.sidebar-list .uk-active {
  background-color: #323130 !important;
  border-left: 5px solid;
  border-color: var(--color-blue) !important;
  font-weight: bold; }

.app-nav-bar {
  width: 100%;
  margin-left: 0px !important;
  height: 25px !important; }

.disabled-text-field .ms-TextField-wrapper .ms-TextField-fieldGroup {
  border: 0px !important; }
  .disabled-text-field .ms-TextField-wrapper .ms-TextField-fieldGroup .ms-TextField-field {
    background: none #323130 !important;
    color: #797775 !important;
    border: none #323130 !important; }

.isApplication {
  display: none !important; }

.isApplication-list {
  height: 96% !important; }

.dropdown-content {
  position: absolute;
  min-width: 160px;
  z-index: 10000; }

.show-element {
  display: block !important; }

.hide-element {
  display: none !important; }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/components/appComponent/appComponent.scss"],"names":[],"mappings":"AAAA;EACC,wBAAgB;EAChB,sBAAc;EACd,oBAAY;EACZ,qBAAa;EACb,kCAAkB;EAElB,gCAAa;EACb,0BAAkB;EAElB,8BAAc;EAEd,iCAAgB;EAChB,qBAAe,EAAA;;ACXhB;EAEC,sBAAsB;EACtB,qBAAqB,EAAA;;AAGtB;EACC;IACC,qBAAqB,EAAA,EACrB;;AAGF;EACC,uBAAuB;EACvB,sBAAsB;EACtB,mCAAmC;EACnC,4CAA4C;EAC5C,2CAA2C,EAAA;;AAG5C;EACC,yBAAyB;EACzB,kCAAkC,EAAA;;AAGnC;EACC,oCAAoC,EAAA;;AAGrC;EACC,uBAAuB,EAAA;;AAGxB;EAEC,sBAAsB;EACtB,oCAAoC,EAAA;;AAGrC;EACC,uBAAuB;EACvB,qBAAqB,EAAA;;AAGtB;EACC,uBAAuB;EACvB,sBAAsB,EAAA;;AAGvB;EACC,uBAAuB;EACvB,qBAAqB,EAAA;;AAGtB;EACC,oCAAoC;EACpC,sBAAsB;EACtB,6BAA6B;EAC7B,6BAA6B,EAAA;;AAG9B;EACC,WAAW,EAAA;;AAGZ;EACC,yBAAyB;EACzB,mBAAmB,EAAA;;AAGpB;EACC,aAAa,EAAA;;AAGd;EACC,4CAA4C;EAC5C,2CAA2C;EAC3C,uBAAuB;EACvB,uBAAuB,EAAA;;AAGxB;EACC,mCAAmC,EAAA;;AAGpC;EACC,0BAA0B;EAC1B,wBAAwB,EAAA;;AAGzB;EACC,oCAA4C,EAAA;;AAG7C;EAEE,oCAA4C;EAC5C,sBAAsB;EACtB,0CAA0C;EAC1C,iBAAiB,EAAA;;AAInB;EACC,WAAW;EACX,2BAA2B;EAC3B,uBAAuB,EAAA;;AAGxB;EAQG,sBAAsB,EAAA;EARzB;IAII,mCAA2C;IAC3C,yBAAoC;IACpC,+BAAuC,EAAA;;AAO3C;EACC,wBAAwB,EAAA;;AAGzB;EACC,sBAAsB,EAAA;;AAGvB;EACC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc,EAAA;;AAGf;EACC,yBAAyB,EAAA;;AAG1B;EACC,wBAAwB,EAAA","sourcesContent":[":root {\n\t--color-primary: #000000;\n\t--color-white: #ffffff;\n\t--color-red: #ff0000;\n\t--color-blue: #00a2ed;\n\t--color-secondary: rgb(34, 34, 34);\n\n\t--font-white: rgb(250, 249, 248);\n\t--font-light-grey: #a4a4a4;\n\n\t--font-medium: 18px !important;\n\n\t--medium-screen: 640px !important;\n\t--small-screen: 960px;\n}\n","@import \"../../theme/variables\";\n\n.app-component {\n\t// display: inline-block !important;\n\theight: 80% !important;\n\twidth: 80% !important;\n}\n\n@media only screen and (max-width: 640px) {\n\t.app-component {\n\t\twidth: 95% !important;\n\t}\n}\n\n.app-topbar {\n\theight: 32px !important;\n\twidth: 100% !important;\n\tcolor: var(--font-white) !important;\n\tborder-bottom-right-radius: unset !important;\n\tborder-bottom-left-radius: unset !important;\n}\n\n.close-button:hover {\n\tcolor: var(--color-white);\n\tbackground-color: var(--color-red);\n}\n\n.title-bar {\n\twidth: calc(100% - 140px) !important;\n}\n\n.app-top-functions {\n\twidth: 100px !important;\n}\n\n.maximized {\n\t// margin-left: -10% !important;\n\twidth: 100% !important;\n\theight: calc(100% - 40px) !important;\n}\n\n.app-content-container {\n\theight: 100% !important;\n\twidth: 80% !important;\n}\n\n.maximized-application {\n\theight: 100% !important;\n\twidth: 100% !important;\n}\n\n.app-sidebar {\n\theight: 100% !important;\n\twidth: 20% !important;\n}\n\n.app-content {\n\theight: calc(100% - 32px) !important;\n\twidth: 100% !important;\n\toverflow-y: scroll !important;\n\toverflow-x: hidden !important;\n}\n\n.scrollbar::-webkit-scrollbar {\n\twidth: 10px;\n}\n\n.scrollbar::-webkit-scrollbar-thumb {\n\tbackground-color: #babac0;\n\tborder-radius: 16px;\n}\n\n.scrollbar::-webkit-scrollbar-button {\n\tdisplay: none;\n}\n\n.app-title {\n\tborder-bottom-right-radius: unset !important;\n\tborder-bottom-left-radius: unset !important;\n\twidth: 200px !important;\n\theight: 100% !important;\n}\n\n.sidebar-list {\n\tcolor: var(--font-white) !important;\n}\n\n.sidebar-list-item {\n\tcursor: pointer !important;\n\tpadding: 10px !important;\n}\n\n.sidebar-list :hover {\n\tbackground-color: rgb(50, 49, 48) !important;\n}\n\n.sidebar-list {\n\t.uk-active {\n\t\tbackground-color: rgb(50, 49, 48) !important;\n\t\tborder-left: 5px solid;\n\t\tborder-color: var(--color-blue) !important;\n\t\tfont-weight: bold;\n\t}\n}\n\n.app-nav-bar {\n\twidth: 100%;\n\tmargin-left: 0px !important;\n\theight: 25px !important;\n}\n\n.disabled-text-field {\n\t.ms-TextField-wrapper {\n\t\t.ms-TextField-fieldGroup {\n\t\t\t.ms-TextField-field {\n\t\t\t\tbackground: none rgb(50, 49, 48) !important;\n\t\t\t\tcolor: rgb(121, 119, 117) !important;\n\t\t\t\tborder: none rgb(50, 49, 48) !important;\n\t\t\t}\n\t\t\tborder: 0px !important;\n\t\t}\n\t}\n}\n\n.isApplication {\n\tdisplay: none !important;\n}\n\n.isApplication-list {\n\theight: 96% !important;\n}\n\n.dropdown-content {\n\tposition: absolute;\n\tmin-width: 160px;\n\tz-index: 10000;\n}\n\n.show-element {\n\tdisplay: block !important;\n}\n\n.hide-element {\n\tdisplay: none !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
